import {
  Card,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import { useMaterialUIController } from "context";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { appConstants } from "utils/appConstants";
import { getScreenRight } from "utils/generic";
import { blank } from "utils/generic";
import { useDispatch } from "react-redux";
import { getUserById } from "utils/superAdminApi";
import { validateField } from "utils/generic";
import { validateEmailField } from "utils/generic";
import { addUserData } from "utils/superAdminApi";
import { updateUserData } from "utils/superAdminApi";
import { showResMsg } from "utils/generic";
import { genericMessage } from "utils/genericMessages";
import { generateDataList } from "utils/generic";
import { fetchRolesData } from "utils/superAdminApi";
const {
  default: DashboardLayout,
} = require("examples/LayoutContainers/DashboardLayout");

const errMsg = {
  color: `red`,
  fontSize: `11px`,
};

let routePath = "/users";

function AddUser(addProps) {
  const { id } = useParams();
  const [screenName, setScreenName] = useState("Add New User");
  const [fNameErr, setfNameErr] = useState(false);
  const [lNameErr, setlNameErr] = useState(false);
  const [roleErr, setRoleErr] = useState(false);
  const [emailTitleErr, setemailTitleErr] = useState("");
  const [emailAddressErrMsg, setEmailAddressErrMsg] = useState("");
  const [roles, setRoles] = useState([]);
  const [disableColor, setDisableColor] = useState(false);
  const [controller] = useMaterialUIController();
  const { sidenavColor } = controller;
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [values, setValues] = React.useState({
    firstName: "",
    lastName: "",
    emailAddress: "",
    userRole: "",
    roleID: "",
    userStatus: "Active",
    id: "",
    userType: "Admin",
    loginURL: appConstants.loginURL,
  });

  const handleChange = (name) => (event) => {
    if (
      event.target.validity !== undefined &&
      event.target.validity.valid === true
    ) {
      setValues({ ...values, [name]: event.target.value });
    } else if (event.target.validity === undefined) {
      setValues({ ...values, [name]: event.target.value });
    }
  };

  useEffect(() => {
    id === undefined
      ? setScreenName("Add New User")
      : setScreenName("Edit User");
    (async () => {
      getRight();
      fetchRoles();
      if (id !== undefined) {
        values._id = id;
        getUserById(
          values,
          (data) => {
            setValues(data.Result_Output);
          },
          dispatch
        );
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  async function getRight() {
    let right = await getScreenRight("Users");
    if (right === "Full Access") {
      setDisableColor(false);
    } else setDisableColor(true);
  }

  const clearErrorStates = () => {
    setfNameErr(false);
    setlNameErr(false);
    setRoleErr(false);
    setEmailAddressErrMsg(false);
  };

  const addNewUser = async () => {
    let mandateFlag = false;
    clearErrorStates();
    mandateFlag = validateField(values.firstName, setfNameErr) || mandateFlag;
    mandateFlag = validateField(values.lastName, setlNameErr) || mandateFlag;
    mandateFlag = validateField(values.roleID, setRoleErr) || mandateFlag;
    mandateFlag =
      validateEmailField(
        values.emailAddress,
        setEmailAddressErrMsg,
        setemailTitleErr
      ) || mandateFlag;
    if (mandateFlag) {
      return;
    }
    const apiFunction = id === undefined ? addUserData : updateUserData;
    apiFunction(
      values,
      (data) => {
        if (data.Result_Status) {
          showResMsg(
            id === undefined ? genericMessage.added : genericMessage.updated,
            1000,
            data.Result_Status,
            navigate,
            routePath
          );
        } else {
          showResMsg(data.Result_Message, 2000, data.Result_Status);
        }
      },
      dispatch
    );
  };

  useEffect(() => {
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  const handleKeyDown = (e) => {
    const inputElement = document.querySelector(".GoogleInput");
    if (e.key === "Enter" && inputElement && inputElement.contains(e.target)) {
      e.preventDefault();
    }
  };

  const fetchRoles = async () => {
    fetchRolesData(values, async (data) => {
      if (data.Result_Output.length > 0) {
        values.roleID = data.Result_Output[0]._id;
      }
      setRoles(await generateDataList(data.Result_Output, "_id", "roleName"));
    });
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox mt={6} mb={3}>
        <Grid
          container
          spacing={1}
          style={{ display: "flex", justifyContent: "center" }}
        >
          <Grid item lg={8} xs={12}>
            <Card sx={{ boxShadow: "none" }}>
              <MDBox
                mx={2}
                mt={-3}
                mb={1.5}
                py={2}
                px={2}
                variant="gradient"
                bgColor={sidenavColor}
                borderRadius="lg"
                coloredShadow="info"
              >
                <MDTypography variant="h6" color="white">
                  {screenName}
                </MDTypography>
              </MDBox>
              <Grid
                container
                p={1.6}
                mb={0.9}
                px={2}
                columnSpacing={{ xs: 2, sm: 2, md: 3, lg: 3 }}
                rowSpacing={{ xs: 2, sm: 2, md: 3, lg: 3 }}
              >
                <Grid item lg={4} xs={12}>
                  <TextField
                    type="text"
                    label="First Name"
                    variant="outlined"
                    fullWidth
                    autoFocus={true}
                    value={values.firstName}
                    onChange={handleChange("firstName")}
                    inputProps={{
                      pattern: "^[a-zA-Z0-9 ]+$",
                      maxLength: 30,
                    }}
                    id={"outlined-error"}
                  />
                  {fNameErr ? (
                    <span style={errMsg}>First Name can't be blank</span>
                  ) : (
                    ""
                  )}
                </Grid>
                <Grid item lg={4} xs={12}>
                  <TextField
                    type="text"
                    label="Last Name"
                    variant="outlined"
                    fullWidth
                    value={values.lastName}
                    onChange={handleChange("lastName")}
                    inputProps={{
                      pattern: "^[a-zA-Z0-9 ]+$",
                      maxLength: 30,
                    }}
                    id={"outlined-error"}
                  />
                  {lNameErr ? (
                    <span style={errMsg}>Last Name can't be blank</span>
                  ) : (
                    ""
                  )}
                </Grid>
                <Grid item lg={4} xs={12}>
                  <FormControl fullWidth>
                    <InputLabel id="user-role" shrink>
                      Role
                    </InputLabel>
                    <Select
                      labelId="user-role"
                      id="select-user-role"
                      style={{ minHeight: "44.11px" }}
                      label="Role"
                      value={values.roleID}
                      onChange={handleChange("roleID")}
                      displayEmpty
                      InputLabelProps={{ shrink: true }}
                      notched
                    >
                      <MenuItem value="" selected>
                        -Select Role Name
                      </MenuItem>
                      {roles}
                    </Select>
                  </FormControl>
                  {roleErr ? (
                    <span style={errMsg}>Role can't be blank</span>
                  ) : (
                    ""
                  )}
                </Grid>
                <Grid item lg={4} xs={12}>
                  <TextField
                    type="text"
                    label="Email Address"
                    variant="outlined"
                    fullWidth
                    inputProps={{
                      maxLength: 50,
                    }}
                    value={values.emailAddress}
                    onChange={handleChange("emailAddress")}
                    disabled={id !== undefined}
                  />
                  {emailAddressErrMsg !== "" ? (
                    <span style={errMsg}>{emailTitleErr}</span>
                  ) : (
                    ""
                  )}
                </Grid>
                <Grid item lg={4} xs={12}>
                  <FormControl fullWidth>
                    <InputLabel id="userStatus">Status </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      style={{ minHeight: "38.11px" }}
                      label="statue"
                      value={values.userStatus}
                      onChange={handleChange("userStatus")}
                      disabled={id !== undefined}
                    >
                      <MenuItem value="Active">Active</MenuItem>
                      <MenuItem value="Inactive">Inactive</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
            </Card>
          </Grid>
        </Grid>
        <Grid
          container
          mt={2}
          // pb={3}
          // columnSpacing={4}
          columnSpacing={{ xs: 2, md: 4, lg: 4 }}
          alignItems="center"
          display="flex"
          justifyContent="center"
        >
          <Grid item xs={12} md={4} spacing={2} lg={1.67}>
            <Link to={"/users"}>
              <MDButton
                className="btn-block center-container-btn btn-warning btn-back rightSpace"
                color="warning"
                fullWidth
                style={{ width: "165px", height: "40px" }}
              >
                Cancel
              </MDButton>
            </Link>
          </Grid>
          <Grid item xs={12} md={4} spacing={2} lg={1.67}>
            <MDButton
              onClick={disableColor ? blank : addNewUser}
              rel="noreferrer"
              variant="gradient"
              className={
                "btn-block center-container-btn btn-warning btn-back rightSpace"
              }
              color={disableColor ? "secondary" : "success"}
              fullWidth
              style={{ width: "165px", height: "40px" }}
            >
              {id !== undefined ? <>Update</> : <>Save</>}
            </MDButton>
          </Grid>
        </Grid>
      </MDBox>
    </DashboardLayout>
  );
}

export default AddUser;
